var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pdf-base',{attrs:{"id":String(_vm.id),"category":"PDF教材","routerName":"Home"}})}
var staticRenderFns = []

export { render, staticRenderFns }